interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  light?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, light }: Props) {
  return (
    <div className="mb-8 max-w-3xl md:mb-10">
      <p className={`flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase ${light ? 'text-accent-300' : 'text-primary-600'}`}>
        <span className={`inline-block h-px w-8 ${light ? 'bg-accent-400' : 'bg-primary-500'}`}></span>
        {eyebrow}
      </p>
      <h2 className={`mt-3 font-heading text-2xl font-bold md:text-4xl ${light ? 'text-background-50' : 'text-foreground-950'}`}>{title}</h2>
      {desc && <p className={`mt-3 text-sm leading-relaxed md:text-base ${light ? 'text-background-50/70' : 'text-foreground-600'}`}>{desc}</p>}
    </div>
  );
}